// extracted by css-extract-rspack-plugin
export default {"placeholder":"J2PJ2","blink":"LvMTm"};